import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import { Outlet, useLocation } from "react-router";
// import Chatbot from "../components/Chatbot";
import SupportDropdown from "../components/Supportmenu";
// import Chatbot from "../components/Supportmenu";

const DefaultLayout = ({ noNavbar, noFooter }) => {
  // The floating support bubble is fixed bottom-right and would sit on top of
  // the assistant page's composer.
  const { pathname } = useLocation();
  const hideSupportBubble = pathname.startsWith("/assistant");

  return (
  <div className="smartfarm-app-layout">
    {!noNavbar && <MainNavbar />}
    <Row className="smartfarm-app-row">
      <MainSidebar />
      <Col
        className="main-content p-0"
        lg={10}
        md={9}
       >

        <Outlet />

      </Col>
      {/* <Chatbot/> */}
      {!hideSupportBubble && <SupportDropdown />}
      {/* <Chatbot /> */}
    </Row>
  </div>
  );
};

DefaultLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

DefaultLayout.defaultProps = {
  noNavbar: false,
  noFooter: false
};

export default DefaultLayout;
